import React, { useEffect, useState } from "react";
import "../styles/ActivePromotion.css";
import "../styles/FeaturedPlacement.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import BusinessHubNavigation from "../components/BusinessHubNavigation.js";
import EditDetails from "../icons/BusinessHub/EditDetails.js";
import TrashIcon from "../icons/BusinessHub/TrashIcon.js";
import TagIcon from "../icons/TagIcon.js";
import DateIcon from "../icons/BusinessHub/DateIcon.js";
import ProductBox from "../icons/ProductBox.js";
import ArrowDownIcon from "../icons/BusinessHub/ArrowDownIcon.js";
import CustomDropdown from "./StatusDropdown.js";
import FilterIcon from "../icons/BusinessHub/FilterIcon.js";
import PlusIcon from "../icons/BusinessHub/PlusIcon.js";
import XIcon from "../icons/XIcon.js";
import SearchIcon from "../icons/BusinessHub/SearchIcon.js";
import SaveIcon from "../icons/SaveIcon.js";
import BoxIcon from "../icons/BoxIcon.js";
import BinIcon from "../icons/BusinessHub/BinIcon.js";
import ProductController from "../controllers/ProductController.js";
import { userService } from "../services/userService.js";
import { useLocation } from "react-router-dom";
import PromotionController from "../controllers/PromotionController.js";
import { useNavigate } from "react-router-dom";

function FeaturedPlacement() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [Mode, setMode] = useState(
    location.state?.Mode ?? searchParams.get("mode") === "edit",
  );
  const productOfferId =
    location.state?.productOfferId ?? searchParams.get("productOfferId");
  const [FeaturedOffer, setFeaturedOffer] = useState();
  const [productsInCampaign, setproductsInCampaign] = useState([]);
  const navigate = useNavigate();

  // const productsInCampaign = [
  //   {
  //     id: 1,
  //     title: "Wireless Mouse",
  //     description: "Ergonomic wireless mouse with adjustable DPI.",
  //     image: "https://via.placeholder.com/80?text=Mouse",
  //   },
  //   {
  //     id: 2,
  //     title: "Gaming Keyboard",
  //     description: "Mechanical keyboard with RGB lighting.",
  //     image: "https://via.placeholder.com/80?text=Keyboard",
  //   },
  //   {
  //     id: 3,
  //     title: "USB-C Hub",
  //     description: "Multi-port adapter with HDMI and USB 3.0.",
  //     image: "https://via.placeholder.com/80?text=Hub",
  //   },
  //   {
  //     id: 4,
  //     title: "Bluetooth Headset",
  //     description: "Noise-cancelling over-ear headphones.",
  //     image: "https://via.placeholder.com/80?text=Headset",
  //   },
  //   {
  //     id: 5,
  //     title: "Laptop Stand",
  //     description: "Adjustable aluminum stand for laptops.",
  //     image: "https://via.placeholder.com/80?text=Stand",
  //   },
  //   {
  //     id: 6,
  //     title: "Webcam HD",
  //     description: "1080p webcam with built-in microphone.",
  //     image: "https://via.placeholder.com/80?text=Webcam",
  //   },
  // ];
  const [CategoryFilters, setCategoryFilters] = useState([]);
  const mockproducts = [
    {
      id: 1,
      name: "Wireless Headphones",
      category: "Electronics",
      vendor: "Azalea Audio",
      skus: [
        { id: "el-2048-blk", name: "Black", code: "WH-1000XM4-BLK", stock: 45 },
        {
          id: "el-2048-slv",
          name: "Silver",
          code: "WH-1000XM4-SLV",
          stock: 32,
        },
        { id: "el-2048-blu", name: "Blue", code: "WH-1000XM4-BLU", stock: 28 },
      ],
    },
    {
      id: 2,
      name: "Office Chair Pro",
      category: "Furniture",
      vendor: "Workstyle",
      skus: [
        { id: "fu-8831-blk", name: "Black", code: "OC-PRO-BLK", stock: 18 },
        { id: "fu-8831-gry", name: "Grey", code: "OC-PRO-GRY", stock: 11 },
      ],
    },
    {
      id: 3,
      name: "Vitamin C Serum",
      category: "Beauty",
      vendor: "Glow Lab",
      skus: [
        { id: "be-1274-30", name: "30ml", code: "VCS-30ML", stock: 24 },
        { id: "be-1274-50", name: "50ml", code: "VCS-50ML", stock: 16 },
      ],
    },
    {
      id: 4,
      name: "Yoga Mat Plus",
      category: "Sports",
      vendor: "Motion Fit",
      skus: [
        { id: "sp-5542-grn", name: "Green", code: "YM-PLUS-GRN", stock: 21 },
        { id: "sp-5542-blk", name: "Black", code: "YM-PLUS-BLK", stock: 13 },
      ],
    },
    {
      id: 5,
      name: "Table Lamp Mini",
      category: "Home",
      vendor: "Nord House",
      skus: [
        { id: "ho-3901-wht", name: "White", code: "TLM-WHT", stock: 14 },
        { id: "ho-3901-bge", name: "Beige", code: "TLM-BGE", stock: 9 },
      ],
    },
    {
      id: 6,
      name: "Denim Jacket",
      category: "Fashion",
      vendor: "Urban Fold",
      skus: [
        { id: "fa-6109-s", name: "Small", code: "DJ-S", stock: 17 },
        { id: "fa-6109-m", name: "Medium", code: "DJ-M", stock: 22 },
        { id: "fa-6109-l", name: "Large", code: "DJ-L", stock: 15 },
      ],
    },
  ];
  const [selectedcategories, setSelectedcategories] = useState([]);
  const [productsearch, setProductsearch] = useState("");
  const [selectedproducts, setSelectedproducts] = useState([]);
  const [selectedskus, setSelectedskus] = useState([]);
  const [expandedproducts, setExpandedproducts] = useState([]);

  const selectedCategoryNames = selectedcategories
    .map(
      (categoryId) =>
        CategoryFilters.find(
          (item) => item.id === categoryId || item.value === categoryId,
        )?.name,
    )
    .filter(Boolean);

  const visibleproducts = mockproducts?.filter(
    (product) =>
      (!selectedcategories?.length ||
        selectedcategories?.includes(product.categoryId) ||
        selectedCategoryNames.includes(product.category)) &&
      `${product.name} ${product.vendor} ${product.category} ${product.skus
        .map((sku) => `${sku.name} ${sku.code}`)
        .join(" ")}`
        .toLowerCase()
        .includes(productsearch.toLowerCase()),
  );
  const [DeleteCamp, setDeleteCamp] = useState(false);
  const [addProdSku, setaddProdSku] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [discountUnit, setDiscountUnit] = useState("");
  const [SelectFilter, setSelectFilter] = useState(false);
  // const [Mode, setMode] = useState(false);
  const views = 2847;
  const clicks = 1234;
  const conversion = 156;
  const Clickrange = (clicks * 100) / views;
  const Convrange = (conversion * 100) / views;
  const handleRemoveCategory = (productToRemove) => {
    setCategoryFilters((prev) =>
      prev?.filter((p) => p.label !== productToRemove.label),
    );
  };
  useEffect(() => {
    const getdata = async () => {
      const getPromotion = await ProductController.getAllCategories({
        Authorization: userService.getUser(),
      });
      setCategoryFilters(
        (getPromotion.data || []).map((category) => ({
          id: category.categoryId,
          label: category.categoryName,
          name: category.categoryName,
          value: category.categoryId,
        })),
      );
    };

    getdata();
  }, []);

  useEffect(() => {
    const getFeaturedByProductOfferId = async () => {
      const getFeaturedByProductOfferId =
        await PromotionController.getFeaturedByProductOfferId({
          Authorization: userService.getUser(),
          productOfferId: productOfferId,
      });
      setFeaturedOffer(getFeaturedByProductOfferId?.data);

      const categoryIds = getFeaturedByProductOfferId?.data?.categoryId;
      setSelectedcategories(
        Array.isArray(categoryIds)
          ? categoryIds.filter(Boolean)
          : categoryIds
            ? [categoryIds]
            : [],
      );

      setproductsInCampaign(getFeaturedByProductOfferId?.data?.products);
    };
    getFeaturedByProductOfferId();
  }, [productOfferId]);

  const formatCategories = (categories) => {
    if (!Array.isArray(categories)) return "";

    return categories
      .map((categoryId) => {
        const category = CategoryFilters.find(
          (item) => item.id === categoryId || item.value === categoryId,
        );

        return category?.name || String(categoryId);
      })
      .join(" - ");
  };

  const formatStatus = (status) => {
    if (!status) return "";

    const lower = status.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };
  const HandleDelete = async () => {
    try {
      const deleteFeature =
        await PromotionController.deleteFeaturedByProductOfferId({
          Authorization: userService.getUser(),
          productOfferId: productOfferId,
        });
      if (deleteFeature.data === true) {
        navigate("/promotions-and-marketing");
      }
    } catch (error) {}
  };
  return (
    <div className="business-hub-bar-screen">
      {DeleteCamp ? (
        <div className="delete-camp-pop-layer">
          <div className="delet-pop-container">
            <div className="delet-pop-container-icon">
              <BinIcon />
            </div>
            <div className="delet-pop-container-header">
              <div className="delet-pop-container-title">Cancel Campaign?</div>
              <div className="delet-pop-container-discription">
                This action cannot be undone
              </div>
            </div>
            <div className="delet-pop-container-alert">
              <div className="cancel-warning">
                <p className="cancel-warning-title">
                  <b>Warning:</b> Cancelling this campaign will:
                </p>

                <ul className="cancel-warning-list">
                  <li>Stop all promotional activities immediately</li>
                  <li>Remove discounts from all products</li>
                  <li>Performance data will be archived</li>
                </ul>
              </div>
            </div>
            <div className="delet-pop-container-action-buttons">
              <div
                className="delet-pop-container-cancel"
                onClick={() => {
                  setMode(false);
                  setDeleteCamp(false);
                }}
              >
                Cancel Campaign
              </div>
              <div
                className="delet-pop-container-Keep"
                onClick={() => setDeleteCamp(false)}
              >
                Keep Campaign
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <div className="business-hub-bar-header-container">
        <BusinessHubHeader />
      </div>
      <div className="active-promotion-page-design-content-container">
        <div className="business-hub-navigation-sidebar">
          <BusinessHubNavigation mode="prod" active="H" />
        </div>
        <div className="active-promotion-container">
          <div className="content-container-active-promotion">
            <div className="product-managemnet-qr-code-containers">
              {Mode ? (
                <div className="edit-promotion-header">
                  <div className="edit-promotion-header-title">
                    <div className="edit-promotion-header-title">
                      <div className="header-data-edit-campaign">
                        <div className="promotion-marketing-header-title-disc">
                          Flash Sale
                        </div>
                        <div className="promotion-marketing-header-title-state">
                          Active
                        </div>
                      </div>
                      <div className="promotion-marketing-header-name">
                        Campaign Name
                      </div>
                      <div className="promotion-marketing-header-containers">
                        <div className="promotion-marketing-header-title">
                          Headphones
                        </div>
                      </div>
                      <div className="edit-promotion-header-title">
                        <div className="promotion-marketing-header-name">
                          Short Description
                        </div>
                        <div className="promotion-marketing-header-containers">
                          <input
                            placeholder="Discounts on premium over-ear and wireless
                            headphones."
                            className="promotion-marketing-header-title-discription"
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="feature-marketing-header-container">
                  {/* <div className="promotion-marketing-header-data-container"> */}
                  {/* <div className="promotion-marketing-header-discription">
                      <div className="promotion-marketing-header-title">
                        Headphones
                        <div className="promotion-marketing-header-title-disc">
                          Flash Sale
                        </div>
                        <div className="promotion-marketing-header-title-state">
                          Active
                        </div>
                      </div>
                      <div className="active-promotion-marketing-header-note">
                        Discounts on premium over-ear and wireless headphones.
                      </div>
                    </div> */}
                  <div className="active-promotion-marketing-header-buttons">
                    {/* <div
                      className="active-promotion-action-icon"
                      onClick={() => setMode(true)}
                    >
                      <EditDetails stroke="#4072C8" />
                    </div> */}
                    <div
                      className="active-promotion-action-icon"
                      onClick={() => HandleDelete()}
                    >
                      <TrashIcon w="18.5px" h="20px" fill="#F44336" />
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              )}
              <div className="active-promotion-marketing-body">
                <div className="active-promotion-marketing-body-data">
                  {/***************************************Campaign info********************************** */}
                  {Mode ? (
                    <div className="active-promotion-marketing-body-data-cont">
                      <div className="active-promotion-marketing-body-data-row">
                        <div className="active-promotion-marketing-body-data-row-main-culomn">
                          <ProductBox />
                          Products in Campaign
                        </div>
                      </div>
                      <div className="active-promotion-marketing-body-specifics">
                        {/* <div className="active-promotion-marketing-body-data-row-culomn">
                          <div className="active-promotion-marketing-body-data-row-culomn-row">
                            Campaign Name
                          </div>
                          <CustomDropdown
                            rightIcon={<ArrowDownIcon />}
                            // value={categoryFilter}
                            // onChange={setCategoryFilter}
                            placeholder="Flash Sale"
                            options={[
                              { label: "All Status", value: "All STATUS" },
                              { label: "Active", value: "ACTIVE" },
                              { label: "Scheduled", value: "UPCOMING" },
                            ]}
                            className="active-promotion-marketing-body-data-row-culomn-row-input"
                            openClassName="promotion-marketing-create-body-content-drop-menu-open"
                            menuClassName="status-drop-menu-container"
                            optionClassName="catagory-status-drop-menu-option"
                          />
                        </div> */}
                        <div className="active-promotion-marketing-body-data-row-culomn">
                          {SelectFilter ? (
                            <div className="edit-campaign-selected-categs">
                              {/* <div className="active-promotion-marketing-body-data-row-culomn-row">
                                Category
                                <div
                                  className="filter-catagories-edit-campaign"
                                  onClick={() => setSelectFilter(true)}
                                >
                                  <FilterIcon />
                                  Filter Categories
                                </div>
                              </div> */}
                              <div className="active-info-marketing-body-data-row-culomn-row-datas">
                                <CustomDropdown
                                  multi
                                  searchable
                                  leftIcon={<FilterIcon />}
                                  value={selectedCategories}
                                  onChange={setSelectedCategories}
                                  placeholder="2 Selected"
                                  options={CategoryFilters.map((item) => ({
                                    label: item.name,
                                    value: item.id,
                                  }))}
                                  className="active-promotion-marketing-body-data-row-culomn-row-inputs"
                                  openClassName="promotion-marketing-create-body-content-drop-menu-open"
                                  menuClassName="status-drop-menu-containers"
                                  optionClassName="catagory-status-drop-menu-options"
                                />
                              </div>
                              {/********************************************************************************** */}
                              {/* <div className="active-promotion-marketing-body-data-row-culomn-row-datas">
                                <CustomDropdown
                                  multi
                                  searchable
                                  value={selectedCategories}
                                  onChange={setSelectedCategories}
                                  placeholder="Select Categories"
                                  options={CategoryFilters.map((item) => ({
                                    label: item.name,
                                    value: item.id,
                                  }))}
                                  className="active-promotion-marketing-body-data-row-culomn-row-inputs"
                                  openClassName="promotion-marketing-create-body-content-drop-menu-open"
                                  menuClassName="status-drop-menu-containers"
                                  optionClassName="catagory-status-drop-menu-options"
                                />
                              </div> */}
                              {/********************************************************************************** */}
                            </div>
                          ) : (
                            <div className="edit-campaign-selected-categs">
                              <div className="active-promotion-marketing-body-data-row-culomn-row">
                                Category
                                <div
                                  className="filter-catagories-edit-campaigns"
                                  onClick={() => setSelectFilter(true)}
                                >
                                  <FilterIcon stroke="white" />2 Selected
                                </div>
                              </div>
                              <div className="active-promotion-marketing-body-data-row-culomn-row-datas">
                                {CategoryFilters.map((product, index) => (
                                  <div
                                    key={index}
                                    className="selected-category-item"
                                  >
                                    <span className="category-name">
                                      {product.name}
                                    </span>
                                    <div
                                      className="remove-category-btn"
                                      onClick={() =>
                                        handleRemoveCategory(product)
                                      }
                                    >
                                      <XIcon />
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          {/********************************************************************* */}
                          <div className="campaign-info-panels">
                            <div className="campaign-products-filtersearch">
                              <input
                                type="text"
                                className="campaign-products-filterinput"
                                placeholder="Search products or SKUs..."
                                value={productsearch}
                                onChange={(e) =>
                                  setProductsearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="campaign-products-list">
                              {visibleproducts?.map((product) => {
                                const isselected = selectedproducts.includes(
                                  product.id,
                                );
                                const isexpanded = expandedproducts.includes(
                                  product.id,
                                );
                                const selectedcount = product?.skus?.filter(
                                  (sku) => selectedskus.includes(sku.id),
                                ).length;

                                return (
                                  <div
                                    key={product.id}
                                    className={`campaign-products-product${
                                      isselected
                                        ? " campaign-products-product-active"
                                        : ""
                                    }`}
                                  >
                                    <div
                                      className="campaign-products-item"
                                      onClick={() => {
                                        if (isselected) {
                                          setSelectedproducts((prev) =>
                                            prev?.filter(
                                              (item) => item !== product.id,
                                            ),
                                          );
                                          setExpandedproducts((prev) =>
                                            prev?.filter(
                                              (item) => item !== product.id,
                                            ),
                                          );
                                          setSelectedskus((prev) =>
                                            prev?.filter(
                                              (skuId) =>
                                                !product.skus.some(
                                                  (sku) => sku.id === skuId,
                                                ),
                                            ),
                                          );
                                          return;
                                        }

                                        setSelectedproducts((prev) => [
                                          ...prev,
                                          product.id,
                                        ]);
                                        setExpandedproducts((prev) =>
                                          prev.includes(product.id)
                                            ? prev
                                            : [...prev, product.id],
                                        );
                                      }}
                                    >
                                      <div className="campaign-products-item-checkbox">
                                        <div
                                          className={`campaign-products-item-checkbox-inner${
                                            isselected
                                              ? " campaign-products-item-checkbox-inner-active"
                                              : ""
                                          }`}
                                        ></div>
                                      </div>
                                      <div className="campaign-products-item-avatar">
                                        {product.name.slice(0, 1)}
                                      </div>
                                      <div className="campaign-products-item-info">
                                        <div className="campaign-products-item-name">
                                          {product.name}
                                        </div>
                                        <div className="campaign-products-item-meta">
                                          {product.skus.length} variants
                                          available
                                          {selectedcount
                                            ? ` • ${selectedcount} selected`
                                            : ""}
                                        </div>
                                      </div>
                                      <div className="campaign-products-item-arrow">
                                        <ArrowDownIcon />
                                      </div>
                                    </div>
                                    {isexpanded ? (
                                      <div className="campaign-products-skulist">
                                        {product.skus.map((sku) => {
                                          const isskuselected =
                                            selectedskus.includes(sku.id);

                                          return (
                                            <div
                                              key={sku.id}
                                              className="campaign-products-skuitem"
                                              onClick={() =>
                                                setSelectedskus((prev) =>
                                                  prev.includes(sku.id)
                                                    ? prev?.filter(
                                                        (item) =>
                                                          item !== sku.id,
                                                      )
                                                    : [...prev, sku.id],
                                                )
                                              }
                                            >
                                              <div className="campaign-products-skucheck">
                                                <div
                                                  className={`campaign-products-skucheckinner${
                                                    isskuselected
                                                      ? " campaign-products-skucheckinner-active"
                                                      : ""
                                                  }`}
                                                ></div>
                                              </div>
                                              <div className="campaign-products-skuinfo">
                                                <div className="campaign-products-skuname">
                                                  {sku.name}
                                                </div>
                                                <div className="campaign-products-skucode">
                                                  {sku.code}
                                                </div>
                                              </div>
                                              <div className="campaign-products-skustock">
                                                Stock {sku.stock}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          {/********************************************************************* */}
                        </div>
                      </div>
                      <div className="active-promotion-marketing-body-specifics">
                        <div className="active-promotion-marketing-body-data-row-culomn">
                          <div className="active-promotion-marketing-body-data-row-culomn-row">
                            Discount
                          </div>
                          <div className="edit-campaign-discount">
                            <input
                              placeholder="30"
                              className="active-promotion-marketing-body-data-row-culomn-row-data-input"
                            ></input>
                            <div className="campaign-discount-unit-switchs">
                              <div
                                className={`campaign-discount-units${
                                  discountUnit === "%" || !discountUnit
                                    ? " campaign-discount-unit-actives"
                                    : ""
                                }`}
                                onClick={() => setDiscountUnit("%")}
                              >
                                %
                              </div>
                              <div
                                className={`campaign-discount-units${
                                  discountUnit === "$"
                                    ? " campaign-discount-unit-actives"
                                    : ""
                                }`}
                                onClick={() => setDiscountUnit("$")}
                              >
                                $
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          Credits Used
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          40
                        </div>
                      </div> */}
                      </div>
                    </div>
                  ) : (
                    <div className="active-promotion-marketing-body-data-cont">
                      <div className="active-promotion-marketing-body-data-row">
                        <div className="active-promotion-marketing-body-data-row-main-culomn">
                          <ProductBox />
                          Products in Placement
                        </div>
                      </div>
                      <div className="view-prod-camp-catg">
                        <div className="view-prod-camp-catg-title">
                          Category
                        </div>
                        <div className="view-prod-camp-catg-text">
                          {formatCategories(selectedcategories)}
                        </div>
                      </div>
                      {productsInCampaign?.length === 0 ? (
                        <div className="edit-profs-campaign-empty">
                          <div className="edit-profs-campaign-empty-icon">
                            <BoxIcon />
                          </div>
                          <div className="edit-profs-campaign-empty-text">
                            No products in this campaign
                          </div>
                          <div className="edit-profs-campaign-empty-alert">
                            ⚠ Campaign must have at least one product
                          </div>
                        </div>
                      ) : (
                        <div className="products-in-campaign">
                          <div className="prods-camp-skus-list">
                            Products & SKUs
                          </div>
                          {productsInCampaign?.map((product) => (
                            <div
                              className="products-card-in-campaign"
                              key={product.productID}
                            >
                              <div className="products-card-in-campaign-disc">
                                {product.dataUrl ? (
                                  <img
                                    src={product.dataUrl}
                                    alt={product.productName}
                                    className="prod-camp-image"
                                  />
                                ) : (
                                  <div className="prod-camp-image" />
                                )}
                                <div className="prods-in-camp-text">
                                  <div className="prods-in-camp-title">
                                    {product.productName}
                                  </div>
                                  <div className="prods-in-camp-note">
                                    {product.productID}
                                  </div>
                                </div>
                              </div>
                              {Mode ? (
                                <div className="remove-product-from-campaign">
                                  <XIcon />
                                </div>
                              ) : null}
                              {/* <div className="products-card-in-campaign-discount">
                            <div className="prods-in-camp-note">
                              Discount Applied
                            </div>
                            <div className="products-card-in-campaign-discount-ammount">
                              {product.discount}
                            </div>
                          </div> */}
                            </div>
                          ))}
                        </div>
                      )}
                      {Mode ? (
                        <div
                          className="edit-campaign-add-prods-skus"
                          onClick={() => setaddProdSku(true)}
                        >
                          <PlusIcon fill="#4072C8" />
                          Add Products & SKUs
                        </div>
                      ) : null}
                      {addProdSku ? (
                        <div className="edit-campaign-add-prods-sku">
                          <div className="edit-campaign-add-prods-sku-search">
                            <SearchIcon />
                            <input
                              placeholder="Search products or SKUs..."
                              className="edit-campaign-add-prods-sku-input"
                            ></input>
                          </div>
                          {/* <div className="edit-campaign-add-prods-sku">
                          <div className="campaign-products-panel">
                            <div className="campaign-products-filtersearch">
                              <input
                                type="text"
                                className="campaign-products-filterinput"
                                placeholder="Search products or SKUs..."
                                value={productsearch}
                                onChange={(e) =>
                                  setProductsearch(e.target.value)
                                }
                              />
                            </div>
                            <div className="campaign-products-list">
                              {visibleproducts.map((product) => {
                                const isselected = selectedproducts.includes(
                                  product.id,
                                );
                                const isexpanded = expandedproducts.includes(
                                  product.id,
                                );
                                const selectedcount = product.skus.filter(
                                  (sku) => selectedskus.includes(sku.id),
                                ).length;

                                return (
                                  <div
                                    key={product.id}
                                    className={`campaign-products-product${
                                      isselected
                                        ? " campaign-products-product-active"
                                        : ""
                                    }`}
                                  >
                                    <div
                                      className="campaign-products-item"
                                      onClick={() => {
                                        if (isselected) {
                                          setSelectedproducts((prev) =>
                                            prev.filter(
                                              (item) => item !== product.id,
                                            ),
                                          );
                                          setExpandedproducts((prev) =>
                                            prev.filter(
                                              (item) => item !== product.id,
                                            ),
                                          );
                                          setSelectedskus((prev) =>
                                            prev.filter(
                                              (skuId) =>
                                                !product.skus.some(
                                                  (sku) => sku.id === skuId,
                                                ),
                                            ),
                                          );
                                          return;
                                        }

                                        setSelectedproducts((prev) => [
                                          ...prev,
                                          product.id,
                                        ]);
                                        setExpandedproducts((prev) =>
                                          prev.includes(product.id)
                                            ? prev
                                            : [...prev, product.id],
                                        );
                                      }}
                                    >
                                      <div className="campaign-products-item-checkbox">
                                        <div
                                          className={`campaign-products-item-checkbox-inner${
                                            isselected
                                              ? " campaign-products-item-checkbox-inner-active"
                                              : ""
                                          }`}
                                        ></div>
                                      </div>
                                      <div className="campaign-products-item-avatar">
                                        {product.name.slice(0, 1)}
                                      </div>
                                      <div className="campaign-products-item-info">
                                        <div className="campaign-products-item-name">
                                          {product.name}
                                        </div>
                                        <div className="campaign-products-item-meta">
                                          {product.skus.length} variants
                                          available
                                          {selectedcount
                                            ? ` • ${selectedcount} selected`
                                            : ""}
                                        </div>
                                      </div>
                                      <div className="campaign-products-item-arrow">
                                        <ArrowDownIcon />
                                      </div>
                                    </div>
                                    {isexpanded ? (
                                      <div className="campaign-products-skulist">
                                        {product.skus.map((sku) => {
                                          const isskuselected =
                                            selectedskus.includes(sku.id);

                                          return (
                                            <div
                                              key={sku.id}
                                              className="campaign-products-skuitem"
                                              onClick={() =>
                                                setSelectedskus((prev) =>
                                                  prev.includes(sku.id)
                                                    ? prev.filter(
                                                        (item) =>
                                                          item !== sku.id,
                                                      )
                                                    : [...prev, sku.id],
                                                )
                                              }
                                            >
                                              <div className="campaign-products-skucheck">
                                                <div
                                                  className={`campaign-products-skucheckinner${
                                                    isskuselected
                                                      ? " campaign-products-skucheckinner-active"
                                                      : ""
                                                  }`}
                                                ></div>
                                              </div>
                                              <div className="campaign-products-skuinfo">
                                                <div className="campaign-products-skuname">
                                                  {sku.name}
                                                </div>
                                                <div className="campaign-products-skucode">
                                                  {sku.code}
                                                </div>
                                              </div>
                                              <div className="campaign-products-skustock">
                                                Stock {sku.stock}
                                              </div>
                                            </div>
                                          );
                                        })}
                                      </div>
                                    ) : null}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div> */}
                        </div>
                      ) : null}
                    </div>
                  )}
                  {/* **************************************Products in Campaign ********************************** */}

                  {/***************************************Campaign Schedule********************************** */}
                  <div className="active-promotion-marketing-body-data-cont">
                    <div className="active-promotion-marketing-body-data-row">
                      <div className="active-promotion-marketing-body-data-row-main-culomn">
                        <DateIcon strokeWidth="1.4" />
                        Campaign Schedule
                      </div>
                    </div>
                    <div className="active-promotion-marketing-body-specifics">
                      <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          Start Date
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          {FeaturedOffer?.startDate}
                        </div>
                      </div>
                      <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          End Date
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          {FeaturedOffer?.endDate}
                        </div>
                      </div>
                    </div>
                    <div className="active-promotion-marketing-body-specifics">
                      <div className="active-promotion-marketing-body-data-row-culomn">
                        <div className="active-promotion-marketing-body-data-row-culomn-row">
                          Campaign Duration
                        </div>
                        <div className="active-promotion-marketing-body-data-row-culomn-row-data">
                          {FeaturedOffer?.featureDuration}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="active-promotion-marketing-body-analitics">
                  <div className="active-promotion-marketing-body-analitics-status">
                    <div className="active-promotion-body-analitics-title">
                      Campaign Status
                    </div>
                    <div className="active-promotion-body-analitics-state">
                      {formatStatus(FeaturedOffer?.status)}
                    </div>
                    <div className="active-promotion-body-analitics-actuale">
                      <span className="comp-status"></span> Running Now
                    </div>
                  </div>
                  <div className="active-promotion-marketing-body-analitics-performance">
                    <div className="active-promotion-marketing-analitics-performance-container">
                      <div className="active-promotion-marketing-analitics-performance-header">
                        Performance
                      </div>
                      <div className="active-promotion-marketing-analitics-performance-body">
                        <div className="active-promotion-marketing-analitics-performance-body-row">
                          <div className="active-promotion-marketing-analitics-performance-row-header">
                            <div className="active-promotion-marketing-analitics-performance-row-title">
                              Views
                            </div>
                            <div className="active-promotion-marketing-analitics-performance-row-numb">
                              {views}
                            </div>
                          </div>
                          <div className="active-promotion-marketing-analitics-performance-row-body">
                            <div
                              className="range-fill"
                            />
                          </div>
                        </div>
                        <div className="active-promotion-marketing-analitics-performance-body-row">
                          <div className="active-promotion-marketing-analitics-performance-row-header">
                            <div className="active-promotion-marketing-analitics-performance-row-title">
                              Clicks
                            </div>
                            <div className="active-promotion-marketing-analitics-performance-row-numb">
                              {clicks}
                            </div>
                          </div>
                          <div className="active-promotion-marketing-analitics-performance-row-body">
                            <div
                              className="range-fill"
                              style={{ width: `${Clickrange}%` }}
                            />
                          </div>
                        </div>
                        <div className="active-promotion-marketing-analitics-performance-body-row">
                          <div className="active-promotion-marketing-analitics-performance-row-header">
                            <div className="active-promotion-marketing-analitics-performance-row-title">
                              Conversions
                            </div>
                            <div className="active-promotion-marketing-analitics-performance-row-numb">
                              {conversion}
                            </div>
                          </div>
                          <div className="active-promotion-marketing-analitics-performance-row-body">
                            <div
                              className="range-fills"
                              style={{ width: `${Convrange}%` }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="active-promotion-marketing-body-analitics-quick-action">
                    <div className="active-promotion-marketing-body-analitics-quick-action-numb">
                      {FeaturedOffer?.creditsUsed}
                    </div>
                    <div className="active-promotion-marketing-body-analitics-quick-action-title">
                      Cridits
                    </div>
                  </div>
                </div> */}
              </div>
              {Mode ? (
                <div className="edit-promotion-footer">
                  <div className="edit-promotion-footer-text">
                    Make changes to your campaign details and schedule
                  </div>
                  <div className="edit-promotion-footer-action-button">
                    <div
                      className="edit-promotion-footer-discard"
                      onClick={() => setDeleteCamp(true)}
                    >
                      Discard Change
                    </div>
                    <div className="edit-promotion-footer-save">
                      <SaveIcon />
                      Save Changes
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FeaturedPlacement;
